import React, { FC, useEffect, useState } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { EFormFieldMessage } from 'common/const';
import { rules, showSuccessMessage } from 'common/helpers';
import { Edit } from 'common/svg';
import { ISubdivision, IUpdateSubdivisionPayload } from 'entities/Subdivision/Subdivision.models';

interface IComponentProps {
  subdivision: ISubdivision | null;
  loading: boolean;
  onSubdivisionUpdate: (payload: IUpdateSubdivisionPayload) => Promise<void>;
}

export const SettingsSubdivisionName: FC<IComponentProps> = ({ subdivision, loading, onSubdivisionUpdate }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [form] = useForm();

  const onClose = () => {
    setOpen(false);
    form.resetFields();
  };

  const onSubmit = () => {
    if (subdivision) {
      form.validateFields().then(({ name }) => {
        onSubdivisionUpdate({
          id: subdivision.id,
          name,
          onSuccess: () => {
            onClose();
            showSuccessMessage('Название подразделения успешно изменено.');
          },
        });
      });
    }
  };

  useEffect(() => {
    if (open && subdivision) {
      form.setFieldValue('name', subdivision.name);
    }
  }, [open, subdivision]);

  return (
    <>
      <div className="subdivision-settings-name mb-14">
        <div className="text-h1 subdivision-settings-name__value">{subdivision?.name}</div>

        <Button
          className="button-icon subdivision-settings-name__edit-btn"
          icon={<Edit className="icon-edit-dark-grey" />}
          onClick={() => setOpen(true)}
        />
      </div>

      <Modal
        rootClassName="redesign modal"
        width={400}
        title="Изменить название подразделения"
        centered
        open={open}
        onCancel={onClose}
        footer={[
          <Button key="cancel" className="button-sm secondary" onClick={onClose} disabled={loading}>
            Отмена
          </Button>,
          <Button key="save" className="button-sm primary" loading={loading} onClick={form.submit}>
            Сохранить
          </Button>,
        ]}
      >
        <Form form={form} requiredMark={false} layout="vertical" onFinish={onSubmit}>
          <Form.Item
            label="Название подразделения"
            name="name"
            rules={[rules.required(true, EFormFieldMessage.EditSubdivisionName)]}
          >
            <Input placeholder="Введите название" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
